// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1Z_RY","additionalInfo":"AgreementModal_additionalInfo__HoXWD"};